// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","formVertical":"_3Xak","formTabbed":"_3RJa","avatar":"_1EHS","searchBar":"_2NnQ","input":"_3F-q","tabs":"_2R0b","active":"_1NoG"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Numbers/NumberSearch/NumberSearch.scss
// module id = 4VC+
// module chunks = 0